"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash256 = exports.hash160 = exports.ripemd160 = exports.sha256 = void 0;
const enc_hex_1 = __importDefault(require("crypto-js/enc-hex"));
const ripemd160_1 = __importDefault(require("crypto-js/ripemd160"));
const sha256_1 = __importDefault(require("crypto-js/sha256"));
function hash(hex, hashingFunction) {
    const hexEncoded = enc_hex_1.default.parse(hex);
    const result = hashingFunction(hexEncoded);
    return result.toString(enc_hex_1.default);
}
/**
 * Performs a single SHA256.
 */
function sha256(hex) {
    return hash(hex, sha256_1.default);
}
exports.sha256 = sha256;
/**
 * Performs a single RIPEMD160.
 */
function ripemd160(hex) {
    return hash(hex, ripemd160_1.default);
}
exports.ripemd160 = ripemd160;
/**
 * Performs a SHA256 followed by a RIPEMD160.
 */
function hash160(hex) {
    const sha = sha256(hex);
    return ripemd160(sha);
}
exports.hash160 = hash160;
/**
 * Performs 2 SHA256.
 */
function hash256(hex) {
    const firstSha = sha256(hex);
    return sha256(firstSha);
}
exports.hash256 = hash256;
